import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: false, name: 'parseIngredients' })
export class ParseIngredientsPipe implements PipeTransform {
  transform(value: string | string[]): string[] {
    if (!value) return [];

    // If it's already an array, return it
    if (Array.isArray(value)) return value;

    try {
      // Try parsing as JSON
      const parsed = JSON.parse(value.replace(/'/g, '"'));
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      // If parsing fails, try splitting by comma
      return value
        .replace(/[\[\]']/g, '')
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
    }
  }
}
